import { LIMITS } from "@anota/shared/limits";

/**
 * Un canvas a imagen comprimida: WebP, o JPEG si el navegador no sabe codificar WebP (Safari), bajando la
 * calidad si hace falta para no pasar del tamaño máximo. Lo usan la captura y el editor de marcas.
 */
export async function encodeCanvas(canvas: HTMLCanvasElement): Promise<Blob | null> {
  for (const [type, quality] of [
    ["image/webp", 0.82],
    ["image/jpeg", 0.82],
    ["image/jpeg", 0.6],
  ] as const) {
    const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, type, quality));
    if (blob && blob.type === type && blob.size <= LIMITS.screenshotBytes) return blob;
  }
  return null;
}
